export const API_NAME = 'invoice-transmission-hub';
export const API_VERSION = 'v1';
export const API_BASE_URL = `${API_NAME}/${API_VERSION}`;
